﻿import { AddAccessibleNavigationHandlers } from '@ClientBase/Generic/NavKeyboardControls'
import { upOrDownOnScrollWheel } from './HelperFunctions'

export const navigationFunctions = () => {
    const header = document.querySelector<HTMLElement>('.main-site-header')
    if (!header) return

    if (window.innerWidth >= 991) {
        closeNavOnBodyClick()
    }

    burgerMenuClickHandler(header)
    makeNavSticky(header)
    adjustNavWidth()
    addBackBtn()
    openNavLevelsClickHandler()
    applyBackBtnClickHandler()
    AddAccessibleNavigationHandlers()
}

const burgerMenuClickHandler = (header: HTMLElement) => {
    const burgerMenu = document.querySelector('.main-site-header__burger-menu')
    if (!burgerMenu) return

    burgerMenu.addEventListener('click', () => {
        header.classList.toggle('nav-open')
        document.body.classList.toggle('nav-open')

        const openNavItems = document.querySelectorAll<HTMLElement>('.hasChildren.open')
        openNavItems.forEach((item: HTMLElement) => {
            item.classList.remove('open')
        })
    })
}

const openNavLevelsClickHandler = () => {
    const mainHeader = document?.querySelector<HTMLElement>(".main-site-header");
    if (!mainHeader) return;

    const isHoverDesktop = () =>
        window.matchMedia("(min-width: 991px) and (hover: hover) and (pointer: fine)").matches;

    mainHeader.addEventListener("mouseenter", (e) => {
        if (!isHoverDesktop()) return;

        const target = e.target as HTMLElement;
        const navItem = target.closest<HTMLElement>(".hasChildren");
        if (!navItem) return;

        const siblings = navItem.closest(".navList")?.querySelectorAll(".hasChildren");
        siblings?.forEach((sib) => {
            if (sib !== navItem) {
                sib.classList.remove("open");
            }
        });
        navItem.classList.add("open");
    }, true);

    mainHeader.addEventListener("mouseleave", (e) => {
        if (!isHoverDesktop()) return;

        const target = e.target as HTMLElement;
        const navItem = target.closest<HTMLElement>(".hasChildren");
        if (!navItem) return;

        const relatedTarget = e.relatedTarget as HTMLElement;
        if (relatedTarget && (navItem.contains(relatedTarget))) return;

        navItem.classList.remove("open");
    }, true);

    mainHeader.addEventListener("click", (e) => {
        const target = e.target as HTMLElement;
        const icon = target.closest<HTMLElement>(".icon");
        if (!icon) return;

        e.stopImmediatePropagation();

        const parent = icon.closest<HTMLElement>(".hasChildren");
        if (!parent) return;

        parent.classList.toggle("open");

        const siblings = parent.closest(".navList")?.querySelectorAll(".hasChildren");
        siblings?.forEach((sib) => {
            if (sib !== parent) {
                sib.classList.remove("open");
            }
        });
    });
};

const applyBackBtnClickHandler = () => {
    const backBtns = document.querySelectorAll(".nav-back-btn");

    backBtns.forEach((el) => {
        el.addEventListener("click", () => {
            el.closest(".hasChildren")?.classList.remove("open");
        });
    });
};

const closeNavOnBodyClick = () => {
    window.addEventListener("click", (event) => {
        const target = event.target as HTMLElement;
        const nav = document.querySelector(".navList");
        const openNavs = document.querySelectorAll(".hasChildren");

        if (target !== nav && !nav?.contains(target)) {
            openNavs.forEach((el) => {
                el.classList.remove("open");
            });
        }
    });
};

//Changes to the DOM
const addBackBtn = () => {
    const hasChildren = document?.querySelectorAll("li.hasChildren");

    if (!hasChildren) return;

    hasChildren.forEach((el) => {
        const backBtn = document.createElement("div");
        backBtn.classList.add("nav-back-btn");
        backBtn.innerHTML = "Back";
        el.querySelector(".navList")?.prepend(backBtn);
    });
};

const makeNavSticky = (header: HTMLElement) => {
    upOrDownOnScrollWheel(header)
}

const adjustNavWidth = () => {
    const links = document.querySelectorAll(
        ".main-site-header .navList > .last > ul > li"
    );

    links.forEach((link) => {
        if (link.classList.contains("hasChildren")) {
            const icon = link.querySelector<HTMLSpanElement>(".icon");
            icon?.addEventListener("click", () => {
                const tile = link.querySelector("ul");
                const tileSize = tile?.getBoundingClientRect();
                const parentNav = link.parentElement?.closest("ul");

                if (!tile || !tileSize || !parentNav) return;
                const totalTileSize: number = tileSize.right + tileSize.width;
                const windowMaxWidth: number = Math.max(
                    window.innerWidth || document.documentElement.clientWidth
                );

                if (totalTileSize > windowMaxWidth) {
                    tile.style.width = "fit-content";
                    parentNav.style.left = "auto";
                    parentNav.style.right = "100%";
                }
            });
        }
    });
};
